var map = {
	"./Aquatics-Center-Diving.jpg": "JjXj",
	"./Arena-Champ-de-Mars-judo.jpg": "lwPz",
	"./Bercy-Arena-Basketball.jpg": "me/Z",
	"./Chteau-de-Versailles.jpg": "GtlE",
	"./Eiffel-Tower-Stadium.jpg": "Rm9K",
	"./Geoffroy-Guichard-Stadium.jpg": "6vKo",
	"./Golf-National.jpg": "zTCG",
	"./Grand-Palais.jpg": "ydYL",
	"./Invalides.jpg": "x88B",
	"./La-Beaujoire-Stadium.jpg": "No/n",
	"./Lyon-Stadium.jpg": "nM6W",
	"./Marina-de-Marseille.jpg": "1als",
	"./Nice-Stadium.jpg": "nors",
	"./Olympic-Village.jpg": "XpnE",
	"./Opening-Ceremony-Visual.jpg": "rs1H",
	"./Parc-des-Princes-Football.jpg": "AEFU",
	"./Paris-La-Defense-Arena.jpg": "F9UU",
	"./ParisGamesMap.svg": "ije6",
	"./Pierre-Mauroy-Stadium.jpg": "znM9",
	"./Porte-de-la-Chapelle-Arena.jpg": "64CV",
	"./Presentation-of-the-logo-on-the-Arc-de-Triomphe.jpg": "Mzve",
	"./Revelation-Paris-2024-on-the-Eiffel-Tower.jpg": "TtR0",
	"./Roland-Garros-Stadium.jpg": "mV30",
	"./Saint-Quentin-en-Yvelines-BMX-Stadium.jpg": "Y1Ut",
	"./Saint-Quentin-en-Yvelines-Velodrome.jpg": "68a+",
	"./South-Paris-Arena.jpg": "mF3v",
	"./Stade-de-France.jpg": "nOcp",
	"./Teahupoo-Tahiti.jpg": "XQee",
	"./Yves-du-Manoir-Stadium.jpg": "Xef/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0